// extracted by mini-css-extract-plugin
export default {"canvas":"NktV_3"};